<template>
    <div class="video-media">
        <PageBreadcrumb :pagetitle="info.title"/>
        <!-- News -->
        <section class="newssec py-5">
            <div class="container">
                <div id="app-instasearch">
                    <div class="input-container form-group">
                        <input type="text" class="form-control" placeholder="Type a name" v-model="authorNameSearchString" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-9 mb-5 mb-lg-0">
                        <div class="row">
                            <div v-for="videos in filteredPhotoFeed" :key="videos.nid" class="col-12 col-md-6 col-lg-6 mb-6">
                                <div class="news-block text-center position-relative">
                                    <div class="news-image shrink-effect position-relative gradient-bt">
                                        <video-embed :params="{autoplay: 0}" v-bind:src="videos.field_video_media"></video-embed>
                                        <div class="news-author text-white bg-primary text-white">
                                            <i class="fa fa-user-o"></i> by <b class="text-white">   </b> <br />
                                            <span><i class="fa fa-calendar"></i>   </span>
                                        </div>
                                    </div>
                                    <div class="news-content">
                                        <div class="author-txt align-self-center">
                                            <span>
                                                <b class="text-danger author-title">{{ videos.title }}</b>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3">
                        <!-- Start SideBarExtras -->
                        <SideBarExtras />
                        <hr>
                        <!-- Start Latest News Sidebar -->
                        <LatestNews />
                        <!-- End Latest News Sidebar -->
                    </div>
                </div>
            </div>
        </section>
        <!-- End News -->
    </div>
</template>

<script>
    import axios from 'axios';
    import Vue from "vue";
    import LatestNews from "../components/LatestNews";
    import PageBreadcrumb from "../components/PageBreadcrumb";
    import SideBarExtras from "../components/SideBarExtras";
    import Embed from 'v-video-embed';
    // global register
    Vue.use(Embed);
    export default{
        name: 'VideoMedia',
        data () {
            return {
                info: { title : "Search and watch videos" },
                videos: [],
                search: '',
                searchedString: "",
                audioFeed: null,
                authorNameSearchString: "",
                photoFeed: null
            }
        },
        components:{
            PageBreadcrumb, LatestNews, SideBarExtras
        },

        mounted() {
            axios
                .get('http://www.fifmi.org.au/fifmiau/web/api/media')
                .then(result => {
                    for (var i = 0; i < result.data.length; i++) {
                        if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].field_media_type === "Videos"){
                            this.videos.push(result.data[i])
                        }
                    }
                })
                .catch(error => console.log(error))
        },
        computed: {

            filteredPhotoFeed: function () {

                let vidz = this.videos;
                const authorNameSearchString = this.authorNameSearchString;

                if(!authorNameSearchString){
                    return vidz;
                }

                // eslint-disable-next-line no-undef
                // let searchString = authorNameSearchString.trim().toLowerCase();

                vidz = vidz.filter(function(item){
                    if(item.title.toLowerCase().indexOf(authorNameSearchString) !== -1){
                        return item;
                    }
                })
                return vidz;
            }
        }
    }
</script>